import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "../../../services/auth.service";
import { EnvService } from "../../../services/env.service";
import { AlertService } from "../../../services/alert.service";

@Component({
  selector: "micro-ticket-approval-detail",
  templateUrl: "./ticket-approval-detail.component.html",
})
export class TicketApprovalDetailComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  @Input() ticketApprovalId: any;
  @Output() persisted = new EventEmitter<any>();
  ticketApproval: any;

  eventCategoryOptions: any[] = []
  eventTypeOptions: any[] = []

  constructor(
    public auth: AuthService,
    private env: EnvService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    if (this.ticketApprovalId) {
      this.load(this.ticketApprovalId);
    } else {
      this.route.params.subscribe((params: Params) => {
        params["id"] === "0" ? this.createNew() : this.load(params["id"]);
      });
    }
  }

  load(id: string): void {
    this.http
      .get(`${this.env.e.url}/task/ticketApprovals/${id}`)
      .subscribe((data) => {
        this.ticketApproval = data;
        this.loadEventCategoryOptions();
        this.loadEventTypeOptions(this.ticketApproval.eventCategoryId);
      });
  }

  loadEventCategoryOptions(): void {
    this.http
      .get(`${this.env.e.url}/task/ticketApprovals/eventCategories`)
      .subscribe((data: any) => {
        this.eventCategoryOptions = data.map((eventCategory: any) => ({
          id: eventCategory.id,
          name: eventCategory.label,
          value: eventCategory.id
        }));
      });
  }

  createNew(): void {
    this.ticketApproval = {
      name: "",
      eventCategoryId: undefined,
      eventTypeId: undefined,
      contactGroupId: undefined,
      approvalOrder: 1,
      notes: "",
      companyId: this.auth.getCompanyId()
    };
    this.loadEventCategoryOptions();
  }

  save(): void {
    const isUpdate = !!this.ticketApproval.id;
    const request = isUpdate
      ? this.http.put(
          `${this.env.e.url}/task/ticketApprovals/${this.ticketApproval.id}`,
          this.ticketApproval,
        )
      : this.http.post(
          `${this.env.e.url}/task/ticketApprovals`,
          this.ticketApproval,
        );
    request.subscribe((data) => {
      this.ticketApproval = data;
      this.alertService.info(
        `${isUpdate ? "Updated" : "Created"} ${this.ticketApproval.name}`,
      );
      this.persisted.emit({ data, action: isUpdate ? "updated" : "added" });
    });
  }

  delete(): void {
    this.http
      .delete(`${this.env.e.url}/task/ticketApprovals/${this.ticketApproval.id}`)
      .subscribe(() => {
        this.persisted.emit({ data: this.ticketApproval, action: "deleted" });
        this.alertService.info(`Deleted ${this.ticketApproval.name}`);
        if (!this.ticketApprovalId) {
          this.router.navigate(["/ticketApprovals"]);
        }
      });
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.ticketApproval.active = target.checked ? "Y" : "N";
  }

  onSelectedChange(key: string, value: any): void {
    this.ticketApproval[key] = value;
  }

  onEventCategoryChange(eventCategoryId: any): void {
    this.onSelectedChange("eventCategoryId", eventCategoryId);
    this.ticketApproval.eventTypeId = undefined;
    this.eventTypeOptions = [];
    this.loadEventTypeOptions(eventCategoryId);
  }

  private loadEventTypeOptions(eventCategoryId: any): void {
    if (!eventCategoryId) {
      return;
    }

    this.http
      .get<any[]>(`${this.env.e.url}/task/ticketApprovals/eventTypes?eventCategoryId=${eventCategoryId}`)
      .subscribe((data: any[]) => {
        this.eventTypeOptions = data.map((eventType: any) => ({
          id: eventType.id,
          name: eventType.label,
        }));
      });
  }
}
